
export default {
  name: 'BasicsIconsRotatingCircle',
  props: {
    classCss: { type: String, default: '' },
  },
}
